
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Route, Routes } from "react-router-dom";
import Api from "services/api"
import toast from "react-hot-toast";
import { ListLayout } from "components/common/ListLayout";
import { changeStatus } from "slices/appointmentSlice";
import { removeMultipleAppointments } from "slices/appointmentSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { setAddAppointmentPopup } from "slices/appointmentSlice";
import AppointmentView from "./appointment/view";
import { mainAccountAppointmentsSelector } from "slices/mainAccount/mainAccountAppointmentSlice";
import { fetchMainAccountAppointments } from "slices/mainAccount/mainAccountAppointmentSlice";
import { getBackgroundStyle } from "components/common/TableColor";
import moment from "moment";
import { useTranslation } from "react-i18next";
const apiService = new Api();

const appointmentRoutes = [
  {
    path: "",
    component: <AppointmentList />,
  },
  {
    path: "view/:id",
    component: <AppointmentView />,
  }
]

export const AppointmentRoutes = () => {

  return (
    <Routes>
      {appointmentRoutes.map(({ path, component }) => (
        <Route key={path} path={path} element={component} />
      ))}
    </Routes>
  )

}

function AppointmentList() {
  const { t } = useTranslation();
  const dispatch = useDispatch()
  const { mainAccountAppointments : appointments, last_page: totalPages, loader, total, current_page,per_page: pageLength } = useSelector(mainAccountAppointmentsSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });

  React.useEffect(() => {
    dispatch(fetchMainAccountAppointments())
  }, [])

  const handleAddAppointmentPopUp = (item) => {
    dispatch(setAddAppointmentPopup({
      show: true,
      item,
    }))
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchMainAccountAppointments())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleAppointments({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(appointments && appointments?.map((appointment) => appointment.id.toString()))


  }

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchMainAccountAppointments(page));
  }, [])

  const handleClose = () => {
    // refAddutton.current.click(); 
    setAddForm({ show: false });

  };

  const handleSelect = (value) => {
    setSelectedValue(value)

  }


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {


    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchMainAccountAppointments(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
          </div>
        </th>
        <th>
          <TableHeaderItem
            title={t("table.appid", { defaultValue: "appid" })}
            sortBy="appid"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title={t("table.service", { defaultValue: "Service" })}
            sortBy="service"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title={t("table.date", { defaultValue: "Date" })}
            sortBy="date"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-2">
          <TableHeaderItem
            title={t("table.language", { defaultValue: "Language" })}
            sortBy="language"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title={t("table.creationDate", { defaultValue: "Creation Date" })}
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-1">
          <TableHeaderItem
            title={t("table.status", { defaultValue: "Status" })}
            sortBy="status"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, appointments, t]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      appointments && appointments?.map((appointment, index) => (
        <AppointmentItem key={appointment?.id || index} appointment={appointment} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddAppointmentPopUp} current_page={current_page} pageLength={pageLength}/>
      ))
    )
  }, [appointments, selectedItems, current_page, pageLength]);

  //#endregion


  return (
    <ListLayout
      heading={t("sidebar.appointments", { defaultValue: "Appointments" })}
      time={true}
      addButtonDisabled={true}
      title=""
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchMainAccountAppointments}
      selectedItems={selectedItems}
      refAddutton={refAddutton}
      addForm={addForm}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder={t("table.searchAppointments", { defaultValue: "Search Appointments ..." })}
      noOfItems={total}
      refAddPopUp="#addAppointmentPopUp"
    >
    </ListLayout>
  )

}


const AppointmentItem = ({
  appointment, index, current_page,pageLength
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(appointment?.status == "active" ? 1 : 0 || 0);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  useEffect(() => {
    setStatus(
      appointment?.status
    )

  }, [appointment]);

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);


    const ClientTimezone = appointment?.appointment_details?.timezone;
    const rawDatetime = appointment?.datetime;
    
    // ➤ Time in UTC (default)
    const formattedDefaultTime = moment.utc(rawDatetime).format('MMM D, YYYY hh:mm A');
    
    const formattedClientTime =  ClientTimezone ? moment.utc(rawDatetime).tz(ClientTimezone?.name).format('MMM D, YYYY hh:mm A') : formattedDefaultTime;

    const formattedCreatedAt = appointment?.created_at
    ? ClientTimezone?.name
        ? moment.utc(appointment.created_at)
            .tz(ClientTimezone.name)
            .format('MMM D, YYYY hh:mm A')
        : moment.utc(appointment.created_at)
            .format('MMM D, YYYY hh:mm A')
    : t("common.nA", { defaultValue: "N/A" });
    
    console.log('ClientTimezonessss', ClientTimezone);

    const getStatusText = (s) => {
      if (!s) return t("common.nA", { defaultValue: "N/A" });
      const normalized = s.toString().toLowerCase();
      return t(`status.${normalized}`, { defaultValue: s });
    };

    const statusLabel =
    appointment?.status === 'cancelled'
      ? appointment?.appointment_details?.is_billable_cancel == 1
        ? t("appointment.cancelledBillable", { defaultValue: 'Cancelled Billable' })
        : t("status.cancelled", { defaultValue: 'Cancelled' })
      : getStatusText(appointment?.status);

  return (
    <tr>
      <td style={getBackgroundStyle(appointment?.status)}>
        <div className="row_check">
          <span>{serial}</span>
        </div>
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        <Link className='link_preview' to={`/user/appointments/view/${appointment?.id}`}>
          {appointment?.appid}
        </Link>
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.type || t("common.nA", { defaultValue: "N/A" })}
      </td>
      {/* <td style={getBackgroundStyle(appointment?.status)}>
         { formattedClientTime || t("common.nA", { defaultValue: "N/A" })}
      </td> */}
      <td style={getBackgroundStyle(appointment?.status)}>
          {appointment?.datetime ? (
              appointment?.appointment_details?.timezone?.name
                  ? moment.tz(appointment.datetime, appointment.appointment_details.timezone.name).format('MMM D, YYYY hh:mm A')
                  : moment(appointment.datetime).format('MMM D, YYYY hh:mm A')
          ) : t("common.nA", { defaultValue: "N/A" })}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}> 
        {appointment?.language?.name || t("common.nA", { defaultValue: "N/A" })}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {formattedCreatedAt}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {statusLabel}
      </td>
    </tr>
  )
}


export default AppointmentList;
